import { Link } from "react-router-dom";
import user1 from "../../images/star-icon.png";
import DynamicImage from "../common/DynamicImage";

export default function BlogCard({blog}) {
  return (
    <div className="col-lg-4 col-md-6" >
      <div className="single-blog-post bg-fffbf5">
        {blog.image && (
          <div className="post-image">
            {/* <img
              src={`${process.env.REACT_APP_UPLOAD_URL}${blog.image.url}`}
              alt={blog.title}
              className="blog-image"
            /> */}
            <DynamicImage image={blog.image} className="blog-image" />
            <div className="image-overlay"></div>
          </div>
        )}

        <div className="post-content">
          <ul className="post-meta">
            <li>
              <div className="post-author post-category d-flex align-items-center">
                <img src={user1} alt="Blog post" />
                <span>{blog.category?.name || "Cyblox"}</span>
              </div>
            </li>
          </ul>

          <h3>
            <Link to={`/blog/${blog.slug}`}>
              {blog.title}
            </Link>
          </h3>

          <p className="limit-2-line-text blog-post-content">
            {blog.description}
          </p>

          <div className="blog-card-footer">
            <Link to={`/blog/${blog.slug}`} className="read-more">
              Read more
              <svg width="18" height="28" viewBox="0 0 24 24" fill="none">
                <path d="M5 12H19M12 5L19 12L12 19" stroke="currentColor" strokeWidth="2" strokeLinecap="round" />
              </svg>
            </Link>
          </div>
        </div>
      </div>
    </div>
  );
}
